import { LessonProblem, StudentProblemResult } from '@yandex-int/k-common';
import { isCodingProblem } from 'platform-components/src/components/coding-problem/utils';
import { isWebProblem } from 'platform-components/src/components/web-problem/utils';
import { useMedia } from 'react-use';

import { PROBLEM_DISPLAY_STATUS } from 'common.components/student-lesson-stat/typings';
import { getProblemDisplayStatus } from 'common.components/student-lesson-stat/utils';
import { isDictation, isOpenAnswer, isTheory } from 'store/problems/utils';

export function getShouldShowProblemOverlay(problem: LessonProblem['problem']) {
    return isWebProblem(problem) || isCodingProblem(problem);
}

export function getShouldHideAnswerControls(
    problemLink: LessonProblem,
    studentProblemResult: StudentProblemResult | null
) {
    const problem = problemLink.problem;
    const status = getProblemDisplayStatus(problemLink, studentProblemResult);
    const isCorrect = status === PROBLEM_DISPLAY_STATUS.CORRECT;
    return isCorrect || isTheory(problem) || isOpenAnswer(problem) || isDictation(problem);
}

export function useIsDesktop() {
    return useMedia('(min-width: 1024px)');
}
